export enum PieceImage {
  PAWN = "assets/images/pawn",
  ROOK = "assets/images/rook",
  BISHOP = "assets/images/bishop",
  KNIGHT = "assets/images/knight",
  QUEEN = "assets/images/queen",
  KING = "assets/images/king",
}
export enum Color {
  Black = 0,
  White = 1,
}

export enum Theme {
  Green = "green",
  Brown = "brown",
}
